export function onRequestCancel() {
	window._cancel?.();
}
